import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        cardContainer: {
            cursor: 'pointer',
            flexDir: 'column',
            width: '100%',
        },
        imgWrapper: {
            position: 'relative',
            marginBottom: {base: remCalc(12), lg: remCalc(32)},
        },
        gridCardOverlay: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'unset',
        },
        tileImage: {maxH: '100%'},
        cardText: {
            textStyle: 'head-xsmall',
            fontWeight: '500',
            color: 'text.default',
        },
    },
    variants: {
        manuals: {
            cardContainer: {
                maxW: remCalc(332),
                padding: 'xsmall.base',
                _hover: {
                    border: {base: 'unset', lg: 'small'},
                    borderStyle: {base: 'unset', lg: 'solid'},
                    borderColor: {base: 'unset', lg: 'border.dark'},
                },
                _focus: {
                    border: {base: 'small', lg: 'unset'},
                    borderStyle: {base: 'solid', lg: 'unset'},
                    borderColor: {base: 'border.dark', lg: 'unset'},
                },
            },
            imgWrapper: {justifyContent: 'center'},
            gridCardOverlay: {backgroundColor: 'background.image'},
            tileImage: {maxH: remCalc(230), width: '100%', objectFit: 'cover'},
        },
        faqs: {
            tileImage: {
                width: '100%',
                height: '100%',
                minHeight: '100%',
                maxWidth: remCalc(332),
                maxHeight: remCalc(230),
                overflow: 'hidden',
                mixBlendMode: 'multiply',
            },
            gridCardOverlay: {
                backgroundColor: 'background.image',
                display: 'flex',
                flexDir: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                background: 'background.image',
            },
            cardContainer: {
                maxWidth: remCalc(332),
                height: '100%',
            },
            imgWrapper: {
                height: '100%',
                // justifyContent: 'center',
                // width: {base: remCalc(167), lg: remCalc(332)},
                // maxWidth: '100%',
                _hover: {
                    bgImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%)`,
                    bgPosition: '50%',
                    bgSize: 'contain',
                    bgRepeat: 'no-repeat',
                    bgBlendMode: 'normal, multiply, normal',
                    bgColor: 'background.light-dark',
                },
                _focus: {
                    bgImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%)`,
                    bgPosition: '50%',
                    bgSize: 'contain',
                    bgRepeat: 'no-repeat',
                    bgBlendMode: 'normal, multiply, normal',
                    bgColor: 'background.light-dark',
                },
            },
        },
    },
    parts: ['cardContainer', 'tileImage', 'cardText', 'gridCardOverlay', 'imgWrapper'],
}
